import axios, { AxiosError } from "axios";
import React, { SetStateAction } from "react";
import {
  ApiConsoleValue,
  HtmlOutputType,
  PdfOutputType,
} from "@components/api-playground/types";

export const refreshPdf = async (
  jsonEditorData: string,
  setPdf: React.Dispatch<SetStateAction<PdfOutputType>>,
  pdf: PdfOutputType,
  setApiConsoleValue: React.Dispatch<SetStateAction<ApiConsoleValue>>
) => {
  try {
    try {
      JSON.parse(jsonEditorData);
      if (!JSON.parse(jsonEditorData).returnType.includes("pdf")) {
        setPdf({ value: "", status: "error" });
        setApiConsoleValue({
          statusCode: "Not a http error",
          message:
            "In order for the api playground to work, you need to specify pdf as a returnType",
        });
        return;
      }
    } catch (error: any) {
      let errorMessage =
        "Your JSON is not valid. It probably contains trailing comma's (these are not captured by the editor)";
      if (error.message) {
        errorMessage = errorMessage + ":" + "\n" + error.message;
      }
      setPdf({ value: "", status: "error" });
      setApiConsoleValue({
        statusCode: "Not a http error",
        message: errorMessage,
      });
      return;
    }

    setPdf({ ...pdf, status: "loading" });
    try {
      await axios
        .post("/api/v0.4", JSON.parse(jsonEditorData), {
          headers: { "x-api-key": "playground558877965" },
        })
        .then((response) => {
          console.log(response.data);
          setPdf({
            value: "data:application/pdf;base64," + response.data.pdf,
            status: "ok",
          });
        });
    } catch (error: any) {
      setPdf({ value: "", status: "error" });
      if (error.response) {
        // this is a real http error
        console.log(error.response);
        setApiConsoleValue({
          statusCode: error.response.status,
          message: error.response.data.message,
          data: error.response.data.data,
        });
      } else {
        // this is a different error
        setApiConsoleValue({
          statusCode: "Not a http error",
          message: error.message,
        });
      }
    }
  } catch (error: any) {
    setPdf({ value: "", status: "error" });
    setApiConsoleValue({
      statusCode: "Not a http error",
      message: error.message,
    });
    console.log(error);
  }
};
